import { Avatar, type AvatarProps } from "@mantine/core";
import md5 from "mini-md5";
import { useEffect, useEffectEvent, useState } from "react";

type Props = Omit<AvatarProps, "name" | "src"> & {
  user: { name?: string | null; email?: string; image?: string | null } | null | undefined;
  gravatarSize?: number;
};

async function getGravatarUrl(email: string, size = 120) {
  const normalized = email.trim().toLowerCase();
  const hash = md5(normalized);
  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=404`;
}

export function ProfilePicture({ user, gravatarSize, ...props }: Props) {
  const [image, setImage] = useState(user?.image);

  const setGravatar = useEffectEvent(async () => {
    if (user?.image) return;
    if (!user?.email) return;
    const url = await getGravatarUrl(user.email, gravatarSize);
    setImage(url);
  });

  useEffect(() => {
    setGravatar();
  }, []);

  return <Avatar radius="xl" src={image} name={user?.name ?? undefined} {...props} />;
}
